import { render } from "./TourSummary.vue?vue&type=template&id=f560df1e&scoped=true"
import script from "./TourSummary.vue?vue&type=script&lang=ts"
export * from "./TourSummary.vue?vue&type=script&lang=ts"

import "./TourSummary.vue?vue&type=style&index=0&id=f560df1e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f560df1e"

export default script